<template>
  <ul class="feed-info">
    <li class="feed-info__item">
      {{$t('feed.feedInfo.number')}}:
      <span class="feed-info__item-count">{{feed.id}}</span>
    </li>
    <li class="feed-info__item">
      {{$t('feed.feedInfo.author')}}:
      <span class="feed-info__item-author">{{feed.uid}}</span>
    </li>
    <li>
      {{$t('feed.feedInfo.date')}}:
      <span class="feed-info__item-date">{{getDate(feed.created_date)}}</span>
    </li>
  </ul>
</template>

<script>
// moment
import moment from "moment";

export default {
  name: "FeedInfo",
  props: {
    feed: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      format: "DD.MM.YYYY HH:mm"
    };
  },
  methods: {
    getDate(date){
      return moment(date).format(this.format);
    }
  }
};
</script>

<style>
.feed-info {
  display: flex;
  padding: 0;
  margin: 0 0 20px 0;
  font-family: "Roboto", "Arial", sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 14px;
  list-style: none;
}

.feed-info__item {
  margin-right: 14px;
}

.feed-info__item:last-child {
  margin-right: 0;
}

.feed-info__item-count,
.feed-info__item-author,
.feed-info__item-date {
  font-weight: 700;
}
</style>
